/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TeamAssignmentsRouteImport } from './routes/team-assignments'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ReliabilityRouteImport } from './routes/reliability'
import { Route as QaResponsibilityRouteImport } from './routes/qa-responsibility'
import { Route as QaRouteImport } from './routes/qa'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as OpsRouteImport } from './routes/ops'
import { Route as MyPageRouteImport } from './routes/my-page'
import { Route as MembersRouteImport } from './routes/members'
import { Route as McpUsageRouteImport } from './routes/mcp-usage'
import { Route as LoginRouteImport } from './routes/login'
import { Route as KpiRouteImport } from './routes/kpi'
import { Route as KnowledgeWikiRouteImport } from './routes/knowledge-wiki'
import { Route as ImprovementsRouteImport } from './routes/improvements'
import { Route as GithubActivityRouteImport } from './routes/github-activity'
import { Route as EvaluationRouteImport } from './routes/evaluation'
import { Route as EngineerEvaluationsRouteImport } from './routes/engineer-evaluations'
import { Route as DesignSearchRouteImport } from './routes/design-search'
import { Route as DbDictionaryRouteImport } from './routes/db-dictionary'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CcUsageRouteImport } from './routes/cc-usage'
import { Route as CcCommandMatrixRouteImport } from './routes/cc-command-matrix'
import { Route as BugEvaluationRouteImport } from './routes/bug-evaluation'
import { Route as AccountsRouteImport } from './routes/accounts'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TeamMeetingsIndexRouteImport } from './routes/team-meetings.index'
import { Route as QaIndexRouteImport } from './routes/qa/index'
import { Route as QaResponsibilityIndexRouteImport } from './routes/qa-responsibility/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects.index'
import { Route as OrgIssuesIndexRouteImport } from './routes/org-issues.index'
import { Route as OpsIndexRouteImport } from './routes/ops.index'
import { Route as MembersIndexRouteImport } from './routes/members/index'
import { Route as KnowledgeWikiIndexRouteImport } from './routes/knowledge-wiki/index'
import { Route as EngineerEvaluationsIndexRouteImport } from './routes/engineer-evaluations/index'
import { Route as DbDictionaryIndexRouteImport } from './routes/db-dictionary/index'
import { Route as CuttysarkIndexRouteImport } from './routes/cuttysark.index'
import { Route as BugEvaluationIndexRouteImport } from './routes/bug-evaluation/index'
import { Route as AccountsIndexRouteImport } from './routes/accounts/index'
import { Route as TeamMeetingsSeriesIdRouteImport } from './routes/team-meetings.$seriesId'
import { Route as QaIdRouteImport } from './routes/qa/$id'
import { Route as QaResponsibilityIssueKeyRouteImport } from './routes/qa-responsibility/$issueKey'
import { Route as ProjectsPmoBoardRouteImport } from './routes/projects.pmo-board'
import { Route as ProjectsPjSandboxRouteImport } from './routes/projects.pj-sandbox'
import { Route as ProjectsMallDivBoardRouteImport } from './routes/projects.mall-div-board'
import { Route as ProjectsLogiDivBoardRouteImport } from './routes/projects.logi-div-board'
import { Route as ProjectsLightTasksRouteImport } from './routes/projects.light-tasks'
import { Route as ProjectsAssignmentHistoryRouteImport } from './routes/projects.assignment-history'
import { Route as ProjectsAllPjBoardRouteImport } from './routes/projects.all-pj-board'
import { Route as ProjectsAcDivBoardRouteImport } from './routes/projects.ac-div-board'
import { Route as ProjectsPjKeyRouteImport } from './routes/projects.$pjKey'
import { Route as OrgIssuesBoardIdRouteImport } from './routes/org-issues.$boardId'
import { Route as OpsSubmitRouteImport } from './routes/ops.submit'
import { Route as OpsMyRequestsRouteImport } from './routes/ops.my-requests'
import { Route as OpsDashboardRouteImport } from './routes/ops.dashboard'
import { Route as OpsAssignmentsRouteImport } from './routes/ops.assignments'
import { Route as MembersIdtKpiRouteImport } from './routes/members/idt-kpi'
import { Route as MembersEngineerBoardRouteImport } from './routes/members/engineer-board'
import { Route as MembersEmailRouteImport } from './routes/members/$email'
import { Route as KnowledgeWikiIdRouteImport } from './routes/knowledge-wiki/$id'
import { Route as IdtDesignerNicknameRouteImport } from './routes/idt-designer.$nickname'
import { Route as EngineerEvaluationsEmailRouteImport } from './routes/engineer-evaluations/$email'
import { Route as DbDictionaryChangesRouteImport } from './routes/db-dictionary/changes'
import { Route as DbDictionarySchemaRouteImport } from './routes/db-dictionary/$schema'
import { Route as BugEvaluationIssueKeyRouteImport } from './routes/bug-evaluation/$issueKey'
import { Route as ProjectsSpecIndexRouteImport } from './routes/projects.spec.index'
import { Route as ProjectsBdIndexRouteImport } from './routes/projects.bd.index'
import { Route as ProjectsPjKeyIndexRouteImport } from './routes/projects.$pjKey.index'
import { Route as DbDictionarySchemaIndexRouteImport } from './routes/db-dictionary/$schema.index'
import { Route as CuttysarkSessionIdIndexRouteImport } from './routes/cuttysark.$sessionId.index'
import { Route as ProjectsBdBdKeyRouteImport } from './routes/projects.bd.$bdKey'
import { Route as ProjectsPjKeySpecRouteImport } from './routes/projects.$pjKey.spec'
import { Route as ProjectsPjKeyMeetingsRouteImport } from './routes/projects.$pjKey.meetings'
import { Route as ProjectsPjKeyBasicDesignRouteImport } from './routes/projects.$pjKey.basic-design'
import { Route as OpsRequestsIdRouteImport } from './routes/ops.requests.$id'
import { Route as DbDictionarySchemaTableRouteImport } from './routes/db-dictionary/$schema.$table'
import { Route as CuttysarkSessionIdStageRouteImport } from './routes/cuttysark.$sessionId.stage'
import { Route as CuttysarkSessionIdOperateRouteImport } from './routes/cuttysark.$sessionId.operate'
import { Route as ProjectsSpecPjKeyIndexRouteImport } from './routes/projects.spec.$pjKey.index'
import { Route as ProjectsSpecPjKeyIntegrationTestRouteImport } from './routes/projects.spec.$pjKey.integration-test'
import { Route as ProjectsBdBdKeyGraphRouteImport } from './routes/projects.bd.$bdKey_.graph'

const TeamAssignmentsRoute = TeamAssignmentsRouteImport.update({
  id: '/team-assignments',
  path: '/team-assignments',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ReliabilityRoute = ReliabilityRouteImport.update({
  id: '/reliability',
  path: '/reliability',
  getParentRoute: () => rootRouteImport,
} as any)
const QaResponsibilityRoute = QaResponsibilityRouteImport.update({
  id: '/qa-responsibility',
  path: '/qa-responsibility',
  getParentRoute: () => rootRouteImport,
} as any)
const QaRoute = QaRouteImport.update({
  id: '/qa',
  path: '/qa',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const OpsRoute = OpsRouteImport.update({
  id: '/ops',
  path: '/ops',
  getParentRoute: () => rootRouteImport,
} as any)
const MyPageRoute = MyPageRouteImport.update({
  id: '/my-page',
  path: '/my-page',
  getParentRoute: () => rootRouteImport,
} as any)
const MembersRoute = MembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => rootRouteImport,
} as any)
const McpUsageRoute = McpUsageRouteImport.update({
  id: '/mcp-usage',
  path: '/mcp-usage',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const KpiRoute = KpiRouteImport.update({
  id: '/kpi',
  path: '/kpi',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeWikiRoute = KnowledgeWikiRouteImport.update({
  id: '/knowledge-wiki',
  path: '/knowledge-wiki',
  getParentRoute: () => rootRouteImport,
} as any)
const ImprovementsRoute = ImprovementsRouteImport.update({
  id: '/improvements',
  path: '/improvements',
  getParentRoute: () => rootRouteImport,
} as any)
const GithubActivityRoute = GithubActivityRouteImport.update({
  id: '/github-activity',
  path: '/github-activity',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluationRoute = EvaluationRouteImport.update({
  id: '/evaluation',
  path: '/evaluation',
  getParentRoute: () => rootRouteImport,
} as any)
const EngineerEvaluationsRoute = EngineerEvaluationsRouteImport.update({
  id: '/engineer-evaluations',
  path: '/engineer-evaluations',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignSearchRoute = DesignSearchRouteImport.update({
  id: '/design-search',
  path: '/design-search',
  getParentRoute: () => rootRouteImport,
} as any)
const DbDictionaryRoute = DbDictionaryRouteImport.update({
  id: '/db-dictionary',
  path: '/db-dictionary',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CcUsageRoute = CcUsageRouteImport.update({
  id: '/cc-usage',
  path: '/cc-usage',
  getParentRoute: () => rootRouteImport,
} as any)
const CcCommandMatrixRoute = CcCommandMatrixRouteImport.update({
  id: '/cc-command-matrix',
  path: '/cc-command-matrix',
  getParentRoute: () => rootRouteImport,
} as any)
const BugEvaluationRoute = BugEvaluationRouteImport.update({
  id: '/bug-evaluation',
  path: '/bug-evaluation',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountsRoute = AccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamMeetingsIndexRoute = TeamMeetingsIndexRouteImport.update({
  id: '/team-meetings/',
  path: '/team-meetings/',
  getParentRoute: () => rootRouteImport,
} as any)
const QaIndexRoute = QaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => QaRoute,
} as any)
const QaResponsibilityIndexRoute = QaResponsibilityIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => QaResponsibilityRoute,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProjectsRoute,
} as any)
const OrgIssuesIndexRoute = OrgIssuesIndexRouteImport.update({
  id: '/org-issues/',
  path: '/org-issues/',
  getParentRoute: () => rootRouteImport,
} as any)
const OpsIndexRoute = OpsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OpsRoute,
} as any)
const MembersIndexRoute = MembersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MembersRoute,
} as any)
const KnowledgeWikiIndexRoute = KnowledgeWikiIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => KnowledgeWikiRoute,
} as any)
const EngineerEvaluationsIndexRoute =
  EngineerEvaluationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => EngineerEvaluationsRoute,
  } as any)
const DbDictionaryIndexRoute = DbDictionaryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DbDictionaryRoute,
} as any)
const CuttysarkIndexRoute = CuttysarkIndexRouteImport.update({
  id: '/cuttysark/',
  path: '/cuttysark/',
  getParentRoute: () => rootRouteImport,
} as any)
const BugEvaluationIndexRoute = BugEvaluationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BugEvaluationRoute,
} as any)
const AccountsIndexRoute = AccountsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountsRoute,
} as any)
const TeamMeetingsSeriesIdRoute = TeamMeetingsSeriesIdRouteImport.update({
  id: '/team-meetings/$seriesId',
  path: '/team-meetings/$seriesId',
  getParentRoute: () => rootRouteImport,
} as any)
const QaIdRoute = QaIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => QaRoute,
} as any)
const QaResponsibilityIssueKeyRoute =
  QaResponsibilityIssueKeyRouteImport.update({
    id: '/$issueKey',
    path: '/$issueKey',
    getParentRoute: () => QaResponsibilityRoute,
  } as any)
const ProjectsPmoBoardRoute = ProjectsPmoBoardRouteImport.update({
  id: '/pmo-board',
  path: '/pmo-board',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProjectsPjSandboxRoute = ProjectsPjSandboxRouteImport.update({
  id: '/pj-sandbox',
  path: '/pj-sandbox',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProjectsMallDivBoardRoute = ProjectsMallDivBoardRouteImport.update({
  id: '/mall-div-board',
  path: '/mall-div-board',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProjectsLogiDivBoardRoute = ProjectsLogiDivBoardRouteImport.update({
  id: '/logi-div-board',
  path: '/logi-div-board',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProjectsLightTasksRoute = ProjectsLightTasksRouteImport.update({
  id: '/light-tasks',
  path: '/light-tasks',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProjectsAssignmentHistoryRoute =
  ProjectsAssignmentHistoryRouteImport.update({
    id: '/assignment-history',
    path: '/assignment-history',
    getParentRoute: () => ProjectsRoute,
  } as any)
const ProjectsAllPjBoardRoute = ProjectsAllPjBoardRouteImport.update({
  id: '/all-pj-board',
  path: '/all-pj-board',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProjectsAcDivBoardRoute = ProjectsAcDivBoardRouteImport.update({
  id: '/ac-div-board',
  path: '/ac-div-board',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProjectsPjKeyRoute = ProjectsPjKeyRouteImport.update({
  id: '/$pjKey',
  path: '/$pjKey',
  getParentRoute: () => ProjectsRoute,
} as any)
const OrgIssuesBoardIdRoute = OrgIssuesBoardIdRouteImport.update({
  id: '/org-issues/$boardId',
  path: '/org-issues/$boardId',
  getParentRoute: () => rootRouteImport,
} as any)
const OpsSubmitRoute = OpsSubmitRouteImport.update({
  id: '/submit',
  path: '/submit',
  getParentRoute: () => OpsRoute,
} as any)
const OpsMyRequestsRoute = OpsMyRequestsRouteImport.update({
  id: '/my-requests',
  path: '/my-requests',
  getParentRoute: () => OpsRoute,
} as any)
const OpsDashboardRoute = OpsDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => OpsRoute,
} as any)
const OpsAssignmentsRoute = OpsAssignmentsRouteImport.update({
  id: '/assignments',
  path: '/assignments',
  getParentRoute: () => OpsRoute,
} as any)
const MembersIdtKpiRoute = MembersIdtKpiRouteImport.update({
  id: '/idt-kpi',
  path: '/idt-kpi',
  getParentRoute: () => MembersRoute,
} as any)
const MembersEngineerBoardRoute = MembersEngineerBoardRouteImport.update({
  id: '/engineer-board',
  path: '/engineer-board',
  getParentRoute: () => MembersRoute,
} as any)
const MembersEmailRoute = MembersEmailRouteImport.update({
  id: '/$email',
  path: '/$email',
  getParentRoute: () => MembersRoute,
} as any)
const KnowledgeWikiIdRoute = KnowledgeWikiIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => KnowledgeWikiRoute,
} as any)
const IdtDesignerNicknameRoute = IdtDesignerNicknameRouteImport.update({
  id: '/idt-designer/$nickname',
  path: '/idt-designer/$nickname',
  getParentRoute: () => rootRouteImport,
} as any)
const EngineerEvaluationsEmailRoute =
  EngineerEvaluationsEmailRouteImport.update({
    id: '/$email',
    path: '/$email',
    getParentRoute: () => EngineerEvaluationsRoute,
  } as any)
const DbDictionaryChangesRoute = DbDictionaryChangesRouteImport.update({
  id: '/changes',
  path: '/changes',
  getParentRoute: () => DbDictionaryRoute,
} as any)
const DbDictionarySchemaRoute = DbDictionarySchemaRouteImport.update({
  id: '/$schema',
  path: '/$schema',
  getParentRoute: () => DbDictionaryRoute,
} as any)
const BugEvaluationIssueKeyRoute = BugEvaluationIssueKeyRouteImport.update({
  id: '/$issueKey',
  path: '/$issueKey',
  getParentRoute: () => BugEvaluationRoute,
} as any)
const ProjectsSpecIndexRoute = ProjectsSpecIndexRouteImport.update({
  id: '/spec/',
  path: '/spec/',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProjectsBdIndexRoute = ProjectsBdIndexRouteImport.update({
  id: '/bd/',
  path: '/bd/',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProjectsPjKeyIndexRoute = ProjectsPjKeyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProjectsPjKeyRoute,
} as any)
const DbDictionarySchemaIndexRoute = DbDictionarySchemaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DbDictionarySchemaRoute,
} as any)
const CuttysarkSessionIdIndexRoute = CuttysarkSessionIdIndexRouteImport.update({
  id: '/cuttysark/$sessionId/',
  path: '/cuttysark/$sessionId/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsBdBdKeyRoute = ProjectsBdBdKeyRouteImport.update({
  id: '/bd/$bdKey',
  path: '/bd/$bdKey',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProjectsPjKeySpecRoute = ProjectsPjKeySpecRouteImport.update({
  id: '/spec',
  path: '/spec',
  getParentRoute: () => ProjectsPjKeyRoute,
} as any)
const ProjectsPjKeyMeetingsRoute = ProjectsPjKeyMeetingsRouteImport.update({
  id: '/meetings',
  path: '/meetings',
  getParentRoute: () => ProjectsPjKeyRoute,
} as any)
const ProjectsPjKeyBasicDesignRoute =
  ProjectsPjKeyBasicDesignRouteImport.update({
    id: '/basic-design',
    path: '/basic-design',
    getParentRoute: () => ProjectsPjKeyRoute,
  } as any)
const OpsRequestsIdRoute = OpsRequestsIdRouteImport.update({
  id: '/requests/$id',
  path: '/requests/$id',
  getParentRoute: () => OpsRoute,
} as any)
const DbDictionarySchemaTableRoute = DbDictionarySchemaTableRouteImport.update({
  id: '/$table',
  path: '/$table',
  getParentRoute: () => DbDictionarySchemaRoute,
} as any)
const CuttysarkSessionIdStageRoute = CuttysarkSessionIdStageRouteImport.update({
  id: '/cuttysark/$sessionId/stage',
  path: '/cuttysark/$sessionId/stage',
  getParentRoute: () => rootRouteImport,
} as any)
const CuttysarkSessionIdOperateRoute =
  CuttysarkSessionIdOperateRouteImport.update({
    id: '/cuttysark/$sessionId/operate',
    path: '/cuttysark/$sessionId/operate',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectsSpecPjKeyIndexRoute = ProjectsSpecPjKeyIndexRouteImport.update({
  id: '/spec/$pjKey/',
  path: '/spec/$pjKey/',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProjectsSpecPjKeyIntegrationTestRoute =
  ProjectsSpecPjKeyIntegrationTestRouteImport.update({
    id: '/spec/$pjKey/integration-test',
    path: '/spec/$pjKey/integration-test',
    getParentRoute: () => ProjectsRoute,
  } as any)
const ProjectsBdBdKeyGraphRoute = ProjectsBdBdKeyGraphRouteImport.update({
  id: '/bd/$bdKey_/graph',
  path: '/bd/$bdKey/graph',
  getParentRoute: () => ProjectsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accounts': typeof AccountsRouteWithChildren
  '/bug-evaluation': typeof BugEvaluationRouteWithChildren
  '/cc-command-matrix': typeof CcCommandMatrixRoute
  '/cc-usage': typeof CcUsageRoute
  '/dashboard': typeof DashboardRoute
  '/db-dictionary': typeof DbDictionaryRouteWithChildren
  '/design-search': typeof DesignSearchRoute
  '/engineer-evaluations': typeof EngineerEvaluationsRouteWithChildren
  '/evaluation': typeof EvaluationRoute
  '/github-activity': typeof GithubActivityRoute
  '/improvements': typeof ImprovementsRoute
  '/knowledge-wiki': typeof KnowledgeWikiRouteWithChildren
  '/kpi': typeof KpiRoute
  '/login': typeof LoginRoute
  '/mcp-usage': typeof McpUsageRoute
  '/members': typeof MembersRouteWithChildren
  '/my-page': typeof MyPageRoute
  '/ops': typeof OpsRouteWithChildren
  '/projects': typeof ProjectsRouteWithChildren
  '/qa': typeof QaRouteWithChildren
  '/qa-responsibility': typeof QaResponsibilityRouteWithChildren
  '/reliability': typeof ReliabilityRoute
  '/settings': typeof SettingsRoute
  '/team-assignments': typeof TeamAssignmentsRoute
  '/bug-evaluation/$issueKey': typeof BugEvaluationIssueKeyRoute
  '/db-dictionary/$schema': typeof DbDictionarySchemaRouteWithChildren
  '/db-dictionary/changes': typeof DbDictionaryChangesRoute
  '/engineer-evaluations/$email': typeof EngineerEvaluationsEmailRoute
  '/idt-designer/$nickname': typeof IdtDesignerNicknameRoute
  '/knowledge-wiki/$id': typeof KnowledgeWikiIdRoute
  '/members/$email': typeof MembersEmailRoute
  '/members/engineer-board': typeof MembersEngineerBoardRoute
  '/members/idt-kpi': typeof MembersIdtKpiRoute
  '/ops/assignments': typeof OpsAssignmentsRoute
  '/ops/dashboard': typeof OpsDashboardRoute
  '/ops/my-requests': typeof OpsMyRequestsRoute
  '/ops/submit': typeof OpsSubmitRoute
  '/org-issues/$boardId': typeof OrgIssuesBoardIdRoute
  '/projects/$pjKey': typeof ProjectsPjKeyRouteWithChildren
  '/projects/ac-div-board': typeof ProjectsAcDivBoardRoute
  '/projects/all-pj-board': typeof ProjectsAllPjBoardRoute
  '/projects/assignment-history': typeof ProjectsAssignmentHistoryRoute
  '/projects/light-tasks': typeof ProjectsLightTasksRoute
  '/projects/logi-div-board': typeof ProjectsLogiDivBoardRoute
  '/projects/mall-div-board': typeof ProjectsMallDivBoardRoute
  '/projects/pj-sandbox': typeof ProjectsPjSandboxRoute
  '/projects/pmo-board': typeof ProjectsPmoBoardRoute
  '/qa-responsibility/$issueKey': typeof QaResponsibilityIssueKeyRoute
  '/qa/$id': typeof QaIdRoute
  '/team-meetings/$seriesId': typeof TeamMeetingsSeriesIdRoute
  '/accounts/': typeof AccountsIndexRoute
  '/bug-evaluation/': typeof BugEvaluationIndexRoute
  '/cuttysark/': typeof CuttysarkIndexRoute
  '/db-dictionary/': typeof DbDictionaryIndexRoute
  '/engineer-evaluations/': typeof EngineerEvaluationsIndexRoute
  '/knowledge-wiki/': typeof KnowledgeWikiIndexRoute
  '/members/': typeof MembersIndexRoute
  '/ops/': typeof OpsIndexRoute
  '/org-issues/': typeof OrgIssuesIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/qa-responsibility/': typeof QaResponsibilityIndexRoute
  '/qa/': typeof QaIndexRoute
  '/team-meetings/': typeof TeamMeetingsIndexRoute
  '/cuttysark/$sessionId/operate': typeof CuttysarkSessionIdOperateRoute
  '/cuttysark/$sessionId/stage': typeof CuttysarkSessionIdStageRoute
  '/db-dictionary/$schema/$table': typeof DbDictionarySchemaTableRoute
  '/ops/requests/$id': typeof OpsRequestsIdRoute
  '/projects/$pjKey/basic-design': typeof ProjectsPjKeyBasicDesignRoute
  '/projects/$pjKey/meetings': typeof ProjectsPjKeyMeetingsRoute
  '/projects/$pjKey/spec': typeof ProjectsPjKeySpecRoute
  '/projects/bd/$bdKey': typeof ProjectsBdBdKeyRoute
  '/cuttysark/$sessionId/': typeof CuttysarkSessionIdIndexRoute
  '/db-dictionary/$schema/': typeof DbDictionarySchemaIndexRoute
  '/projects/$pjKey/': typeof ProjectsPjKeyIndexRoute
  '/projects/bd/': typeof ProjectsBdIndexRoute
  '/projects/spec/': typeof ProjectsSpecIndexRoute
  '/projects/bd/$bdKey/graph': typeof ProjectsBdBdKeyGraphRoute
  '/projects/spec/$pjKey/integration-test': typeof ProjectsSpecPjKeyIntegrationTestRoute
  '/projects/spec/$pjKey/': typeof ProjectsSpecPjKeyIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cc-command-matrix': typeof CcCommandMatrixRoute
  '/cc-usage': typeof CcUsageRoute
  '/dashboard': typeof DashboardRoute
  '/design-search': typeof DesignSearchRoute
  '/evaluation': typeof EvaluationRoute
  '/github-activity': typeof GithubActivityRoute
  '/improvements': typeof ImprovementsRoute
  '/kpi': typeof KpiRoute
  '/login': typeof LoginRoute
  '/mcp-usage': typeof McpUsageRoute
  '/my-page': typeof MyPageRoute
  '/reliability': typeof ReliabilityRoute
  '/settings': typeof SettingsRoute
  '/team-assignments': typeof TeamAssignmentsRoute
  '/bug-evaluation/$issueKey': typeof BugEvaluationIssueKeyRoute
  '/db-dictionary/changes': typeof DbDictionaryChangesRoute
  '/engineer-evaluations/$email': typeof EngineerEvaluationsEmailRoute
  '/idt-designer/$nickname': typeof IdtDesignerNicknameRoute
  '/knowledge-wiki/$id': typeof KnowledgeWikiIdRoute
  '/members/$email': typeof MembersEmailRoute
  '/members/engineer-board': typeof MembersEngineerBoardRoute
  '/members/idt-kpi': typeof MembersIdtKpiRoute
  '/ops/assignments': typeof OpsAssignmentsRoute
  '/ops/dashboard': typeof OpsDashboardRoute
  '/ops/my-requests': typeof OpsMyRequestsRoute
  '/ops/submit': typeof OpsSubmitRoute
  '/org-issues/$boardId': typeof OrgIssuesBoardIdRoute
  '/projects/ac-div-board': typeof ProjectsAcDivBoardRoute
  '/projects/all-pj-board': typeof ProjectsAllPjBoardRoute
  '/projects/assignment-history': typeof ProjectsAssignmentHistoryRoute
  '/projects/light-tasks': typeof ProjectsLightTasksRoute
  '/projects/logi-div-board': typeof ProjectsLogiDivBoardRoute
  '/projects/mall-div-board': typeof ProjectsMallDivBoardRoute
  '/projects/pj-sandbox': typeof ProjectsPjSandboxRoute
  '/projects/pmo-board': typeof ProjectsPmoBoardRoute
  '/qa-responsibility/$issueKey': typeof QaResponsibilityIssueKeyRoute
  '/qa/$id': typeof QaIdRoute
  '/team-meetings/$seriesId': typeof TeamMeetingsSeriesIdRoute
  '/accounts': typeof AccountsIndexRoute
  '/bug-evaluation': typeof BugEvaluationIndexRoute
  '/cuttysark': typeof CuttysarkIndexRoute
  '/db-dictionary': typeof DbDictionaryIndexRoute
  '/engineer-evaluations': typeof EngineerEvaluationsIndexRoute
  '/knowledge-wiki': typeof KnowledgeWikiIndexRoute
  '/members': typeof MembersIndexRoute
  '/ops': typeof OpsIndexRoute
  '/org-issues': typeof OrgIssuesIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/qa-responsibility': typeof QaResponsibilityIndexRoute
  '/qa': typeof QaIndexRoute
  '/team-meetings': typeof TeamMeetingsIndexRoute
  '/cuttysark/$sessionId/operate': typeof CuttysarkSessionIdOperateRoute
  '/cuttysark/$sessionId/stage': typeof CuttysarkSessionIdStageRoute
  '/db-dictionary/$schema/$table': typeof DbDictionarySchemaTableRoute
  '/ops/requests/$id': typeof OpsRequestsIdRoute
  '/projects/$pjKey/basic-design': typeof ProjectsPjKeyBasicDesignRoute
  '/projects/$pjKey/meetings': typeof ProjectsPjKeyMeetingsRoute
  '/projects/$pjKey/spec': typeof ProjectsPjKeySpecRoute
  '/projects/bd/$bdKey': typeof ProjectsBdBdKeyRoute
  '/cuttysark/$sessionId': typeof CuttysarkSessionIdIndexRoute
  '/db-dictionary/$schema': typeof DbDictionarySchemaIndexRoute
  '/projects/$pjKey': typeof ProjectsPjKeyIndexRoute
  '/projects/bd': typeof ProjectsBdIndexRoute
  '/projects/spec': typeof ProjectsSpecIndexRoute
  '/projects/bd/$bdKey/graph': typeof ProjectsBdBdKeyGraphRoute
  '/projects/spec/$pjKey/integration-test': typeof ProjectsSpecPjKeyIntegrationTestRoute
  '/projects/spec/$pjKey': typeof ProjectsSpecPjKeyIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accounts': typeof AccountsRouteWithChildren
  '/bug-evaluation': typeof BugEvaluationRouteWithChildren
  '/cc-command-matrix': typeof CcCommandMatrixRoute
  '/cc-usage': typeof CcUsageRoute
  '/dashboard': typeof DashboardRoute
  '/db-dictionary': typeof DbDictionaryRouteWithChildren
  '/design-search': typeof DesignSearchRoute
  '/engineer-evaluations': typeof EngineerEvaluationsRouteWithChildren
  '/evaluation': typeof EvaluationRoute
  '/github-activity': typeof GithubActivityRoute
  '/improvements': typeof ImprovementsRoute
  '/knowledge-wiki': typeof KnowledgeWikiRouteWithChildren
  '/kpi': typeof KpiRoute
  '/login': typeof LoginRoute
  '/mcp-usage': typeof McpUsageRoute
  '/members': typeof MembersRouteWithChildren
  '/my-page': typeof MyPageRoute
  '/ops': typeof OpsRouteWithChildren
  '/projects': typeof ProjectsRouteWithChildren
  '/qa': typeof QaRouteWithChildren
  '/qa-responsibility': typeof QaResponsibilityRouteWithChildren
  '/reliability': typeof ReliabilityRoute
  '/settings': typeof SettingsRoute
  '/team-assignments': typeof TeamAssignmentsRoute
  '/bug-evaluation/$issueKey': typeof BugEvaluationIssueKeyRoute
  '/db-dictionary/$schema': typeof DbDictionarySchemaRouteWithChildren
  '/db-dictionary/changes': typeof DbDictionaryChangesRoute
  '/engineer-evaluations/$email': typeof EngineerEvaluationsEmailRoute
  '/idt-designer/$nickname': typeof IdtDesignerNicknameRoute
  '/knowledge-wiki/$id': typeof KnowledgeWikiIdRoute
  '/members/$email': typeof MembersEmailRoute
  '/members/engineer-board': typeof MembersEngineerBoardRoute
  '/members/idt-kpi': typeof MembersIdtKpiRoute
  '/ops/assignments': typeof OpsAssignmentsRoute
  '/ops/dashboard': typeof OpsDashboardRoute
  '/ops/my-requests': typeof OpsMyRequestsRoute
  '/ops/submit': typeof OpsSubmitRoute
  '/org-issues/$boardId': typeof OrgIssuesBoardIdRoute
  '/projects/$pjKey': typeof ProjectsPjKeyRouteWithChildren
  '/projects/ac-div-board': typeof ProjectsAcDivBoardRoute
  '/projects/all-pj-board': typeof ProjectsAllPjBoardRoute
  '/projects/assignment-history': typeof ProjectsAssignmentHistoryRoute
  '/projects/light-tasks': typeof ProjectsLightTasksRoute
  '/projects/logi-div-board': typeof ProjectsLogiDivBoardRoute
  '/projects/mall-div-board': typeof ProjectsMallDivBoardRoute
  '/projects/pj-sandbox': typeof ProjectsPjSandboxRoute
  '/projects/pmo-board': typeof ProjectsPmoBoardRoute
  '/qa-responsibility/$issueKey': typeof QaResponsibilityIssueKeyRoute
  '/qa/$id': typeof QaIdRoute
  '/team-meetings/$seriesId': typeof TeamMeetingsSeriesIdRoute
  '/accounts/': typeof AccountsIndexRoute
  '/bug-evaluation/': typeof BugEvaluationIndexRoute
  '/cuttysark/': typeof CuttysarkIndexRoute
  '/db-dictionary/': typeof DbDictionaryIndexRoute
  '/engineer-evaluations/': typeof EngineerEvaluationsIndexRoute
  '/knowledge-wiki/': typeof KnowledgeWikiIndexRoute
  '/members/': typeof MembersIndexRoute
  '/ops/': typeof OpsIndexRoute
  '/org-issues/': typeof OrgIssuesIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/qa-responsibility/': typeof QaResponsibilityIndexRoute
  '/qa/': typeof QaIndexRoute
  '/team-meetings/': typeof TeamMeetingsIndexRoute
  '/cuttysark/$sessionId/operate': typeof CuttysarkSessionIdOperateRoute
  '/cuttysark/$sessionId/stage': typeof CuttysarkSessionIdStageRoute
  '/db-dictionary/$schema/$table': typeof DbDictionarySchemaTableRoute
  '/ops/requests/$id': typeof OpsRequestsIdRoute
  '/projects/$pjKey/basic-design': typeof ProjectsPjKeyBasicDesignRoute
  '/projects/$pjKey/meetings': typeof ProjectsPjKeyMeetingsRoute
  '/projects/$pjKey/spec': typeof ProjectsPjKeySpecRoute
  '/projects/bd/$bdKey': typeof ProjectsBdBdKeyRoute
  '/cuttysark/$sessionId/': typeof CuttysarkSessionIdIndexRoute
  '/db-dictionary/$schema/': typeof DbDictionarySchemaIndexRoute
  '/projects/$pjKey/': typeof ProjectsPjKeyIndexRoute
  '/projects/bd/': typeof ProjectsBdIndexRoute
  '/projects/spec/': typeof ProjectsSpecIndexRoute
  '/projects/bd/$bdKey_/graph': typeof ProjectsBdBdKeyGraphRoute
  '/projects/spec/$pjKey/integration-test': typeof ProjectsSpecPjKeyIntegrationTestRoute
  '/projects/spec/$pjKey/': typeof ProjectsSpecPjKeyIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accounts'
    | '/bug-evaluation'
    | '/cc-command-matrix'
    | '/cc-usage'
    | '/dashboard'
    | '/db-dictionary'
    | '/design-search'
    | '/engineer-evaluations'
    | '/evaluation'
    | '/github-activity'
    | '/improvements'
    | '/knowledge-wiki'
    | '/kpi'
    | '/login'
    | '/mcp-usage'
    | '/members'
    | '/my-page'
    | '/ops'
    | '/projects'
    | '/qa'
    | '/qa-responsibility'
    | '/reliability'
    | '/settings'
    | '/team-assignments'
    | '/bug-evaluation/$issueKey'
    | '/db-dictionary/$schema'
    | '/db-dictionary/changes'
    | '/engineer-evaluations/$email'
    | '/idt-designer/$nickname'
    | '/knowledge-wiki/$id'
    | '/members/$email'
    | '/members/engineer-board'
    | '/members/idt-kpi'
    | '/ops/assignments'
    | '/ops/dashboard'
    | '/ops/my-requests'
    | '/ops/submit'
    | '/org-issues/$boardId'
    | '/projects/$pjKey'
    | '/projects/ac-div-board'
    | '/projects/all-pj-board'
    | '/projects/assignment-history'
    | '/projects/light-tasks'
    | '/projects/logi-div-board'
    | '/projects/mall-div-board'
    | '/projects/pj-sandbox'
    | '/projects/pmo-board'
    | '/qa-responsibility/$issueKey'
    | '/qa/$id'
    | '/team-meetings/$seriesId'
    | '/accounts/'
    | '/bug-evaluation/'
    | '/cuttysark/'
    | '/db-dictionary/'
    | '/engineer-evaluations/'
    | '/knowledge-wiki/'
    | '/members/'
    | '/ops/'
    | '/org-issues/'
    | '/projects/'
    | '/qa-responsibility/'
    | '/qa/'
    | '/team-meetings/'
    | '/cuttysark/$sessionId/operate'
    | '/cuttysark/$sessionId/stage'
    | '/db-dictionary/$schema/$table'
    | '/ops/requests/$id'
    | '/projects/$pjKey/basic-design'
    | '/projects/$pjKey/meetings'
    | '/projects/$pjKey/spec'
    | '/projects/bd/$bdKey'
    | '/cuttysark/$sessionId/'
    | '/db-dictionary/$schema/'
    | '/projects/$pjKey/'
    | '/projects/bd/'
    | '/projects/spec/'
    | '/projects/bd/$bdKey/graph'
    | '/projects/spec/$pjKey/integration-test'
    | '/projects/spec/$pjKey/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cc-command-matrix'
    | '/cc-usage'
    | '/dashboard'
    | '/design-search'
    | '/evaluation'
    | '/github-activity'
    | '/improvements'
    | '/kpi'
    | '/login'
    | '/mcp-usage'
    | '/my-page'
    | '/reliability'
    | '/settings'
    | '/team-assignments'
    | '/bug-evaluation/$issueKey'
    | '/db-dictionary/changes'
    | '/engineer-evaluations/$email'
    | '/idt-designer/$nickname'
    | '/knowledge-wiki/$id'
    | '/members/$email'
    | '/members/engineer-board'
    | '/members/idt-kpi'
    | '/ops/assignments'
    | '/ops/dashboard'
    | '/ops/my-requests'
    | '/ops/submit'
    | '/org-issues/$boardId'
    | '/projects/ac-div-board'
    | '/projects/all-pj-board'
    | '/projects/assignment-history'
    | '/projects/light-tasks'
    | '/projects/logi-div-board'
    | '/projects/mall-div-board'
    | '/projects/pj-sandbox'
    | '/projects/pmo-board'
    | '/qa-responsibility/$issueKey'
    | '/qa/$id'
    | '/team-meetings/$seriesId'
    | '/accounts'
    | '/bug-evaluation'
    | '/cuttysark'
    | '/db-dictionary'
    | '/engineer-evaluations'
    | '/knowledge-wiki'
    | '/members'
    | '/ops'
    | '/org-issues'
    | '/projects'
    | '/qa-responsibility'
    | '/qa'
    | '/team-meetings'
    | '/cuttysark/$sessionId/operate'
    | '/cuttysark/$sessionId/stage'
    | '/db-dictionary/$schema/$table'
    | '/ops/requests/$id'
    | '/projects/$pjKey/basic-design'
    | '/projects/$pjKey/meetings'
    | '/projects/$pjKey/spec'
    | '/projects/bd/$bdKey'
    | '/cuttysark/$sessionId'
    | '/db-dictionary/$schema'
    | '/projects/$pjKey'
    | '/projects/bd'
    | '/projects/spec'
    | '/projects/bd/$bdKey/graph'
    | '/projects/spec/$pjKey/integration-test'
    | '/projects/spec/$pjKey'
  id:
    | '__root__'
    | '/'
    | '/accounts'
    | '/bug-evaluation'
    | '/cc-command-matrix'
    | '/cc-usage'
    | '/dashboard'
    | '/db-dictionary'
    | '/design-search'
    | '/engineer-evaluations'
    | '/evaluation'
    | '/github-activity'
    | '/improvements'
    | '/knowledge-wiki'
    | '/kpi'
    | '/login'
    | '/mcp-usage'
    | '/members'
    | '/my-page'
    | '/ops'
    | '/projects'
    | '/qa'
    | '/qa-responsibility'
    | '/reliability'
    | '/settings'
    | '/team-assignments'
    | '/bug-evaluation/$issueKey'
    | '/db-dictionary/$schema'
    | '/db-dictionary/changes'
    | '/engineer-evaluations/$email'
    | '/idt-designer/$nickname'
    | '/knowledge-wiki/$id'
    | '/members/$email'
    | '/members/engineer-board'
    | '/members/idt-kpi'
    | '/ops/assignments'
    | '/ops/dashboard'
    | '/ops/my-requests'
    | '/ops/submit'
    | '/org-issues/$boardId'
    | '/projects/$pjKey'
    | '/projects/ac-div-board'
    | '/projects/all-pj-board'
    | '/projects/assignment-history'
    | '/projects/light-tasks'
    | '/projects/logi-div-board'
    | '/projects/mall-div-board'
    | '/projects/pj-sandbox'
    | '/projects/pmo-board'
    | '/qa-responsibility/$issueKey'
    | '/qa/$id'
    | '/team-meetings/$seriesId'
    | '/accounts/'
    | '/bug-evaluation/'
    | '/cuttysark/'
    | '/db-dictionary/'
    | '/engineer-evaluations/'
    | '/knowledge-wiki/'
    | '/members/'
    | '/ops/'
    | '/org-issues/'
    | '/projects/'
    | '/qa-responsibility/'
    | '/qa/'
    | '/team-meetings/'
    | '/cuttysark/$sessionId/operate'
    | '/cuttysark/$sessionId/stage'
    | '/db-dictionary/$schema/$table'
    | '/ops/requests/$id'
    | '/projects/$pjKey/basic-design'
    | '/projects/$pjKey/meetings'
    | '/projects/$pjKey/spec'
    | '/projects/bd/$bdKey'
    | '/cuttysark/$sessionId/'
    | '/db-dictionary/$schema/'
    | '/projects/$pjKey/'
    | '/projects/bd/'
    | '/projects/spec/'
    | '/projects/bd/$bdKey_/graph'
    | '/projects/spec/$pjKey/integration-test'
    | '/projects/spec/$pjKey/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountsRoute: typeof AccountsRouteWithChildren
  BugEvaluationRoute: typeof BugEvaluationRouteWithChildren
  CcCommandMatrixRoute: typeof CcCommandMatrixRoute
  CcUsageRoute: typeof CcUsageRoute
  DashboardRoute: typeof DashboardRoute
  DbDictionaryRoute: typeof DbDictionaryRouteWithChildren
  DesignSearchRoute: typeof DesignSearchRoute
  EngineerEvaluationsRoute: typeof EngineerEvaluationsRouteWithChildren
  EvaluationRoute: typeof EvaluationRoute
  GithubActivityRoute: typeof GithubActivityRoute
  ImprovementsRoute: typeof ImprovementsRoute
  KnowledgeWikiRoute: typeof KnowledgeWikiRouteWithChildren
  KpiRoute: typeof KpiRoute
  LoginRoute: typeof LoginRoute
  McpUsageRoute: typeof McpUsageRoute
  MembersRoute: typeof MembersRouteWithChildren
  MyPageRoute: typeof MyPageRoute
  OpsRoute: typeof OpsRouteWithChildren
  ProjectsRoute: typeof ProjectsRouteWithChildren
  QaRoute: typeof QaRouteWithChildren
  QaResponsibilityRoute: typeof QaResponsibilityRouteWithChildren
  ReliabilityRoute: typeof ReliabilityRoute
  SettingsRoute: typeof SettingsRoute
  TeamAssignmentsRoute: typeof TeamAssignmentsRoute
  IdtDesignerNicknameRoute: typeof IdtDesignerNicknameRoute
  OrgIssuesBoardIdRoute: typeof OrgIssuesBoardIdRoute
  TeamMeetingsSeriesIdRoute: typeof TeamMeetingsSeriesIdRoute
  CuttysarkIndexRoute: typeof CuttysarkIndexRoute
  OrgIssuesIndexRoute: typeof OrgIssuesIndexRoute
  TeamMeetingsIndexRoute: typeof TeamMeetingsIndexRoute
  CuttysarkSessionIdOperateRoute: typeof CuttysarkSessionIdOperateRoute
  CuttysarkSessionIdStageRoute: typeof CuttysarkSessionIdStageRoute
  CuttysarkSessionIdIndexRoute: typeof CuttysarkSessionIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/team-assignments': {
      id: '/team-assignments'
      path: '/team-assignments'
      fullPath: '/team-assignments'
      preLoaderRoute: typeof TeamAssignmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reliability': {
      id: '/reliability'
      path: '/reliability'
      fullPath: '/reliability'
      preLoaderRoute: typeof ReliabilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qa-responsibility': {
      id: '/qa-responsibility'
      path: '/qa-responsibility'
      fullPath: '/qa-responsibility'
      preLoaderRoute: typeof QaResponsibilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qa': {
      id: '/qa'
      path: '/qa'
      fullPath: '/qa'
      preLoaderRoute: typeof QaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ops': {
      id: '/ops'
      path: '/ops'
      fullPath: '/ops'
      preLoaderRoute: typeof OpsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-page': {
      id: '/my-page'
      path: '/my-page'
      fullPath: '/my-page'
      preLoaderRoute: typeof MyPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/members': {
      id: '/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof MembersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mcp-usage': {
      id: '/mcp-usage'
      path: '/mcp-usage'
      fullPath: '/mcp-usage'
      preLoaderRoute: typeof McpUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kpi': {
      id: '/kpi'
      path: '/kpi'
      fullPath: '/kpi'
      preLoaderRoute: typeof KpiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge-wiki': {
      id: '/knowledge-wiki'
      path: '/knowledge-wiki'
      fullPath: '/knowledge-wiki'
      preLoaderRoute: typeof KnowledgeWikiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/improvements': {
      id: '/improvements'
      path: '/improvements'
      fullPath: '/improvements'
      preLoaderRoute: typeof ImprovementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/github-activity': {
      id: '/github-activity'
      path: '/github-activity'
      fullPath: '/github-activity'
      preLoaderRoute: typeof GithubActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluation': {
      id: '/evaluation'
      path: '/evaluation'
      fullPath: '/evaluation'
      preLoaderRoute: typeof EvaluationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/engineer-evaluations': {
      id: '/engineer-evaluations'
      path: '/engineer-evaluations'
      fullPath: '/engineer-evaluations'
      preLoaderRoute: typeof EngineerEvaluationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design-search': {
      id: '/design-search'
      path: '/design-search'
      fullPath: '/design-search'
      preLoaderRoute: typeof DesignSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/db-dictionary': {
      id: '/db-dictionary'
      path: '/db-dictionary'
      fullPath: '/db-dictionary'
      preLoaderRoute: typeof DbDictionaryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cc-usage': {
      id: '/cc-usage'
      path: '/cc-usage'
      fullPath: '/cc-usage'
      preLoaderRoute: typeof CcUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cc-command-matrix': {
      id: '/cc-command-matrix'
      path: '/cc-command-matrix'
      fullPath: '/cc-command-matrix'
      preLoaderRoute: typeof CcCommandMatrixRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bug-evaluation': {
      id: '/bug-evaluation'
      path: '/bug-evaluation'
      fullPath: '/bug-evaluation'
      preLoaderRoute: typeof BugEvaluationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounts': {
      id: '/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team-meetings/': {
      id: '/team-meetings/'
      path: '/team-meetings'
      fullPath: '/team-meetings/'
      preLoaderRoute: typeof TeamMeetingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qa/': {
      id: '/qa/'
      path: '/'
      fullPath: '/qa/'
      preLoaderRoute: typeof QaIndexRouteImport
      parentRoute: typeof QaRoute
    }
    '/qa-responsibility/': {
      id: '/qa-responsibility/'
      path: '/'
      fullPath: '/qa-responsibility/'
      preLoaderRoute: typeof QaResponsibilityIndexRouteImport
      parentRoute: typeof QaResponsibilityRoute
    }
    '/projects/': {
      id: '/projects/'
      path: '/'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/org-issues/': {
      id: '/org-issues/'
      path: '/org-issues'
      fullPath: '/org-issues/'
      preLoaderRoute: typeof OrgIssuesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ops/': {
      id: '/ops/'
      path: '/'
      fullPath: '/ops/'
      preLoaderRoute: typeof OpsIndexRouteImport
      parentRoute: typeof OpsRoute
    }
    '/members/': {
      id: '/members/'
      path: '/'
      fullPath: '/members/'
      preLoaderRoute: typeof MembersIndexRouteImport
      parentRoute: typeof MembersRoute
    }
    '/knowledge-wiki/': {
      id: '/knowledge-wiki/'
      path: '/'
      fullPath: '/knowledge-wiki/'
      preLoaderRoute: typeof KnowledgeWikiIndexRouteImport
      parentRoute: typeof KnowledgeWikiRoute
    }
    '/engineer-evaluations/': {
      id: '/engineer-evaluations/'
      path: '/'
      fullPath: '/engineer-evaluations/'
      preLoaderRoute: typeof EngineerEvaluationsIndexRouteImport
      parentRoute: typeof EngineerEvaluationsRoute
    }
    '/db-dictionary/': {
      id: '/db-dictionary/'
      path: '/'
      fullPath: '/db-dictionary/'
      preLoaderRoute: typeof DbDictionaryIndexRouteImport
      parentRoute: typeof DbDictionaryRoute
    }
    '/cuttysark/': {
      id: '/cuttysark/'
      path: '/cuttysark'
      fullPath: '/cuttysark/'
      preLoaderRoute: typeof CuttysarkIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bug-evaluation/': {
      id: '/bug-evaluation/'
      path: '/'
      fullPath: '/bug-evaluation/'
      preLoaderRoute: typeof BugEvaluationIndexRouteImport
      parentRoute: typeof BugEvaluationRoute
    }
    '/accounts/': {
      id: '/accounts/'
      path: '/'
      fullPath: '/accounts/'
      preLoaderRoute: typeof AccountsIndexRouteImport
      parentRoute: typeof AccountsRoute
    }
    '/team-meetings/$seriesId': {
      id: '/team-meetings/$seriesId'
      path: '/team-meetings/$seriesId'
      fullPath: '/team-meetings/$seriesId'
      preLoaderRoute: typeof TeamMeetingsSeriesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qa/$id': {
      id: '/qa/$id'
      path: '/$id'
      fullPath: '/qa/$id'
      preLoaderRoute: typeof QaIdRouteImport
      parentRoute: typeof QaRoute
    }
    '/qa-responsibility/$issueKey': {
      id: '/qa-responsibility/$issueKey'
      path: '/$issueKey'
      fullPath: '/qa-responsibility/$issueKey'
      preLoaderRoute: typeof QaResponsibilityIssueKeyRouteImport
      parentRoute: typeof QaResponsibilityRoute
    }
    '/projects/pmo-board': {
      id: '/projects/pmo-board'
      path: '/pmo-board'
      fullPath: '/projects/pmo-board'
      preLoaderRoute: typeof ProjectsPmoBoardRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/pj-sandbox': {
      id: '/projects/pj-sandbox'
      path: '/pj-sandbox'
      fullPath: '/projects/pj-sandbox'
      preLoaderRoute: typeof ProjectsPjSandboxRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/mall-div-board': {
      id: '/projects/mall-div-board'
      path: '/mall-div-board'
      fullPath: '/projects/mall-div-board'
      preLoaderRoute: typeof ProjectsMallDivBoardRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/logi-div-board': {
      id: '/projects/logi-div-board'
      path: '/logi-div-board'
      fullPath: '/projects/logi-div-board'
      preLoaderRoute: typeof ProjectsLogiDivBoardRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/light-tasks': {
      id: '/projects/light-tasks'
      path: '/light-tasks'
      fullPath: '/projects/light-tasks'
      preLoaderRoute: typeof ProjectsLightTasksRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/assignment-history': {
      id: '/projects/assignment-history'
      path: '/assignment-history'
      fullPath: '/projects/assignment-history'
      preLoaderRoute: typeof ProjectsAssignmentHistoryRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/all-pj-board': {
      id: '/projects/all-pj-board'
      path: '/all-pj-board'
      fullPath: '/projects/all-pj-board'
      preLoaderRoute: typeof ProjectsAllPjBoardRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/ac-div-board': {
      id: '/projects/ac-div-board'
      path: '/ac-div-board'
      fullPath: '/projects/ac-div-board'
      preLoaderRoute: typeof ProjectsAcDivBoardRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/$pjKey': {
      id: '/projects/$pjKey'
      path: '/$pjKey'
      fullPath: '/projects/$pjKey'
      preLoaderRoute: typeof ProjectsPjKeyRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/org-issues/$boardId': {
      id: '/org-issues/$boardId'
      path: '/org-issues/$boardId'
      fullPath: '/org-issues/$boardId'
      preLoaderRoute: typeof OrgIssuesBoardIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ops/submit': {
      id: '/ops/submit'
      path: '/submit'
      fullPath: '/ops/submit'
      preLoaderRoute: typeof OpsSubmitRouteImport
      parentRoute: typeof OpsRoute
    }
    '/ops/my-requests': {
      id: '/ops/my-requests'
      path: '/my-requests'
      fullPath: '/ops/my-requests'
      preLoaderRoute: typeof OpsMyRequestsRouteImport
      parentRoute: typeof OpsRoute
    }
    '/ops/dashboard': {
      id: '/ops/dashboard'
      path: '/dashboard'
      fullPath: '/ops/dashboard'
      preLoaderRoute: typeof OpsDashboardRouteImport
      parentRoute: typeof OpsRoute
    }
    '/ops/assignments': {
      id: '/ops/assignments'
      path: '/assignments'
      fullPath: '/ops/assignments'
      preLoaderRoute: typeof OpsAssignmentsRouteImport
      parentRoute: typeof OpsRoute
    }
    '/members/idt-kpi': {
      id: '/members/idt-kpi'
      path: '/idt-kpi'
      fullPath: '/members/idt-kpi'
      preLoaderRoute: typeof MembersIdtKpiRouteImport
      parentRoute: typeof MembersRoute
    }
    '/members/engineer-board': {
      id: '/members/engineer-board'
      path: '/engineer-board'
      fullPath: '/members/engineer-board'
      preLoaderRoute: typeof MembersEngineerBoardRouteImport
      parentRoute: typeof MembersRoute
    }
    '/members/$email': {
      id: '/members/$email'
      path: '/$email'
      fullPath: '/members/$email'
      preLoaderRoute: typeof MembersEmailRouteImport
      parentRoute: typeof MembersRoute
    }
    '/knowledge-wiki/$id': {
      id: '/knowledge-wiki/$id'
      path: '/$id'
      fullPath: '/knowledge-wiki/$id'
      preLoaderRoute: typeof KnowledgeWikiIdRouteImport
      parentRoute: typeof KnowledgeWikiRoute
    }
    '/idt-designer/$nickname': {
      id: '/idt-designer/$nickname'
      path: '/idt-designer/$nickname'
      fullPath: '/idt-designer/$nickname'
      preLoaderRoute: typeof IdtDesignerNicknameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/engineer-evaluations/$email': {
      id: '/engineer-evaluations/$email'
      path: '/$email'
      fullPath: '/engineer-evaluations/$email'
      preLoaderRoute: typeof EngineerEvaluationsEmailRouteImport
      parentRoute: typeof EngineerEvaluationsRoute
    }
    '/db-dictionary/changes': {
      id: '/db-dictionary/changes'
      path: '/changes'
      fullPath: '/db-dictionary/changes'
      preLoaderRoute: typeof DbDictionaryChangesRouteImport
      parentRoute: typeof DbDictionaryRoute
    }
    '/db-dictionary/$schema': {
      id: '/db-dictionary/$schema'
      path: '/$schema'
      fullPath: '/db-dictionary/$schema'
      preLoaderRoute: typeof DbDictionarySchemaRouteImport
      parentRoute: typeof DbDictionaryRoute
    }
    '/bug-evaluation/$issueKey': {
      id: '/bug-evaluation/$issueKey'
      path: '/$issueKey'
      fullPath: '/bug-evaluation/$issueKey'
      preLoaderRoute: typeof BugEvaluationIssueKeyRouteImport
      parentRoute: typeof BugEvaluationRoute
    }
    '/projects/spec/': {
      id: '/projects/spec/'
      path: '/spec'
      fullPath: '/projects/spec/'
      preLoaderRoute: typeof ProjectsSpecIndexRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/bd/': {
      id: '/projects/bd/'
      path: '/bd'
      fullPath: '/projects/bd/'
      preLoaderRoute: typeof ProjectsBdIndexRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/$pjKey/': {
      id: '/projects/$pjKey/'
      path: '/'
      fullPath: '/projects/$pjKey/'
      preLoaderRoute: typeof ProjectsPjKeyIndexRouteImport
      parentRoute: typeof ProjectsPjKeyRoute
    }
    '/db-dictionary/$schema/': {
      id: '/db-dictionary/$schema/'
      path: '/'
      fullPath: '/db-dictionary/$schema/'
      preLoaderRoute: typeof DbDictionarySchemaIndexRouteImport
      parentRoute: typeof DbDictionarySchemaRoute
    }
    '/cuttysark/$sessionId/': {
      id: '/cuttysark/$sessionId/'
      path: '/cuttysark/$sessionId'
      fullPath: '/cuttysark/$sessionId/'
      preLoaderRoute: typeof CuttysarkSessionIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/bd/$bdKey': {
      id: '/projects/bd/$bdKey'
      path: '/bd/$bdKey'
      fullPath: '/projects/bd/$bdKey'
      preLoaderRoute: typeof ProjectsBdBdKeyRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/$pjKey/spec': {
      id: '/projects/$pjKey/spec'
      path: '/spec'
      fullPath: '/projects/$pjKey/spec'
      preLoaderRoute: typeof ProjectsPjKeySpecRouteImport
      parentRoute: typeof ProjectsPjKeyRoute
    }
    '/projects/$pjKey/meetings': {
      id: '/projects/$pjKey/meetings'
      path: '/meetings'
      fullPath: '/projects/$pjKey/meetings'
      preLoaderRoute: typeof ProjectsPjKeyMeetingsRouteImport
      parentRoute: typeof ProjectsPjKeyRoute
    }
    '/projects/$pjKey/basic-design': {
      id: '/projects/$pjKey/basic-design'
      path: '/basic-design'
      fullPath: '/projects/$pjKey/basic-design'
      preLoaderRoute: typeof ProjectsPjKeyBasicDesignRouteImport
      parentRoute: typeof ProjectsPjKeyRoute
    }
    '/ops/requests/$id': {
      id: '/ops/requests/$id'
      path: '/requests/$id'
      fullPath: '/ops/requests/$id'
      preLoaderRoute: typeof OpsRequestsIdRouteImport
      parentRoute: typeof OpsRoute
    }
    '/db-dictionary/$schema/$table': {
      id: '/db-dictionary/$schema/$table'
      path: '/$table'
      fullPath: '/db-dictionary/$schema/$table'
      preLoaderRoute: typeof DbDictionarySchemaTableRouteImport
      parentRoute: typeof DbDictionarySchemaRoute
    }
    '/cuttysark/$sessionId/stage': {
      id: '/cuttysark/$sessionId/stage'
      path: '/cuttysark/$sessionId/stage'
      fullPath: '/cuttysark/$sessionId/stage'
      preLoaderRoute: typeof CuttysarkSessionIdStageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cuttysark/$sessionId/operate': {
      id: '/cuttysark/$sessionId/operate'
      path: '/cuttysark/$sessionId/operate'
      fullPath: '/cuttysark/$sessionId/operate'
      preLoaderRoute: typeof CuttysarkSessionIdOperateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/spec/$pjKey/': {
      id: '/projects/spec/$pjKey/'
      path: '/spec/$pjKey'
      fullPath: '/projects/spec/$pjKey/'
      preLoaderRoute: typeof ProjectsSpecPjKeyIndexRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/spec/$pjKey/integration-test': {
      id: '/projects/spec/$pjKey/integration-test'
      path: '/spec/$pjKey/integration-test'
      fullPath: '/projects/spec/$pjKey/integration-test'
      preLoaderRoute: typeof ProjectsSpecPjKeyIntegrationTestRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/bd/$bdKey_/graph': {
      id: '/projects/bd/$bdKey_/graph'
      path: '/bd/$bdKey/graph'
      fullPath: '/projects/bd/$bdKey/graph'
      preLoaderRoute: typeof ProjectsBdBdKeyGraphRouteImport
      parentRoute: typeof ProjectsRoute
    }
  }
}

interface AccountsRouteChildren {
  AccountsIndexRoute: typeof AccountsIndexRoute
}

const AccountsRouteChildren: AccountsRouteChildren = {
  AccountsIndexRoute: AccountsIndexRoute,
}

const AccountsRouteWithChildren = AccountsRoute._addFileChildren(
  AccountsRouteChildren,
)

interface BugEvaluationRouteChildren {
  BugEvaluationIssueKeyRoute: typeof BugEvaluationIssueKeyRoute
  BugEvaluationIndexRoute: typeof BugEvaluationIndexRoute
}

const BugEvaluationRouteChildren: BugEvaluationRouteChildren = {
  BugEvaluationIssueKeyRoute: BugEvaluationIssueKeyRoute,
  BugEvaluationIndexRoute: BugEvaluationIndexRoute,
}

const BugEvaluationRouteWithChildren = BugEvaluationRoute._addFileChildren(
  BugEvaluationRouteChildren,
)

interface DbDictionarySchemaRouteChildren {
  DbDictionarySchemaTableRoute: typeof DbDictionarySchemaTableRoute
  DbDictionarySchemaIndexRoute: typeof DbDictionarySchemaIndexRoute
}

const DbDictionarySchemaRouteChildren: DbDictionarySchemaRouteChildren = {
  DbDictionarySchemaTableRoute: DbDictionarySchemaTableRoute,
  DbDictionarySchemaIndexRoute: DbDictionarySchemaIndexRoute,
}

const DbDictionarySchemaRouteWithChildren =
  DbDictionarySchemaRoute._addFileChildren(DbDictionarySchemaRouteChildren)

interface DbDictionaryRouteChildren {
  DbDictionarySchemaRoute: typeof DbDictionarySchemaRouteWithChildren
  DbDictionaryChangesRoute: typeof DbDictionaryChangesRoute
  DbDictionaryIndexRoute: typeof DbDictionaryIndexRoute
}

const DbDictionaryRouteChildren: DbDictionaryRouteChildren = {
  DbDictionarySchemaRoute: DbDictionarySchemaRouteWithChildren,
  DbDictionaryChangesRoute: DbDictionaryChangesRoute,
  DbDictionaryIndexRoute: DbDictionaryIndexRoute,
}

const DbDictionaryRouteWithChildren = DbDictionaryRoute._addFileChildren(
  DbDictionaryRouteChildren,
)

interface EngineerEvaluationsRouteChildren {
  EngineerEvaluationsEmailRoute: typeof EngineerEvaluationsEmailRoute
  EngineerEvaluationsIndexRoute: typeof EngineerEvaluationsIndexRoute
}

const EngineerEvaluationsRouteChildren: EngineerEvaluationsRouteChildren = {
  EngineerEvaluationsEmailRoute: EngineerEvaluationsEmailRoute,
  EngineerEvaluationsIndexRoute: EngineerEvaluationsIndexRoute,
}

const EngineerEvaluationsRouteWithChildren =
  EngineerEvaluationsRoute._addFileChildren(EngineerEvaluationsRouteChildren)

interface KnowledgeWikiRouteChildren {
  KnowledgeWikiIdRoute: typeof KnowledgeWikiIdRoute
  KnowledgeWikiIndexRoute: typeof KnowledgeWikiIndexRoute
}

const KnowledgeWikiRouteChildren: KnowledgeWikiRouteChildren = {
  KnowledgeWikiIdRoute: KnowledgeWikiIdRoute,
  KnowledgeWikiIndexRoute: KnowledgeWikiIndexRoute,
}

const KnowledgeWikiRouteWithChildren = KnowledgeWikiRoute._addFileChildren(
  KnowledgeWikiRouteChildren,
)

interface MembersRouteChildren {
  MembersEmailRoute: typeof MembersEmailRoute
  MembersEngineerBoardRoute: typeof MembersEngineerBoardRoute
  MembersIdtKpiRoute: typeof MembersIdtKpiRoute
  MembersIndexRoute: typeof MembersIndexRoute
}

const MembersRouteChildren: MembersRouteChildren = {
  MembersEmailRoute: MembersEmailRoute,
  MembersEngineerBoardRoute: MembersEngineerBoardRoute,
  MembersIdtKpiRoute: MembersIdtKpiRoute,
  MembersIndexRoute: MembersIndexRoute,
}

const MembersRouteWithChildren =
  MembersRoute._addFileChildren(MembersRouteChildren)

interface OpsRouteChildren {
  OpsAssignmentsRoute: typeof OpsAssignmentsRoute
  OpsDashboardRoute: typeof OpsDashboardRoute
  OpsMyRequestsRoute: typeof OpsMyRequestsRoute
  OpsSubmitRoute: typeof OpsSubmitRoute
  OpsIndexRoute: typeof OpsIndexRoute
  OpsRequestsIdRoute: typeof OpsRequestsIdRoute
}

const OpsRouteChildren: OpsRouteChildren = {
  OpsAssignmentsRoute: OpsAssignmentsRoute,
  OpsDashboardRoute: OpsDashboardRoute,
  OpsMyRequestsRoute: OpsMyRequestsRoute,
  OpsSubmitRoute: OpsSubmitRoute,
  OpsIndexRoute: OpsIndexRoute,
  OpsRequestsIdRoute: OpsRequestsIdRoute,
}

const OpsRouteWithChildren = OpsRoute._addFileChildren(OpsRouteChildren)

interface ProjectsPjKeyRouteChildren {
  ProjectsPjKeyBasicDesignRoute: typeof ProjectsPjKeyBasicDesignRoute
  ProjectsPjKeyMeetingsRoute: typeof ProjectsPjKeyMeetingsRoute
  ProjectsPjKeySpecRoute: typeof ProjectsPjKeySpecRoute
  ProjectsPjKeyIndexRoute: typeof ProjectsPjKeyIndexRoute
}

const ProjectsPjKeyRouteChildren: ProjectsPjKeyRouteChildren = {
  ProjectsPjKeyBasicDesignRoute: ProjectsPjKeyBasicDesignRoute,
  ProjectsPjKeyMeetingsRoute: ProjectsPjKeyMeetingsRoute,
  ProjectsPjKeySpecRoute: ProjectsPjKeySpecRoute,
  ProjectsPjKeyIndexRoute: ProjectsPjKeyIndexRoute,
}

const ProjectsPjKeyRouteWithChildren = ProjectsPjKeyRoute._addFileChildren(
  ProjectsPjKeyRouteChildren,
)

interface ProjectsRouteChildren {
  ProjectsPjKeyRoute: typeof ProjectsPjKeyRouteWithChildren
  ProjectsAcDivBoardRoute: typeof ProjectsAcDivBoardRoute
  ProjectsAllPjBoardRoute: typeof ProjectsAllPjBoardRoute
  ProjectsAssignmentHistoryRoute: typeof ProjectsAssignmentHistoryRoute
  ProjectsLightTasksRoute: typeof ProjectsLightTasksRoute
  ProjectsLogiDivBoardRoute: typeof ProjectsLogiDivBoardRoute
  ProjectsMallDivBoardRoute: typeof ProjectsMallDivBoardRoute
  ProjectsPjSandboxRoute: typeof ProjectsPjSandboxRoute
  ProjectsPmoBoardRoute: typeof ProjectsPmoBoardRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  ProjectsBdBdKeyRoute: typeof ProjectsBdBdKeyRoute
  ProjectsBdIndexRoute: typeof ProjectsBdIndexRoute
  ProjectsSpecIndexRoute: typeof ProjectsSpecIndexRoute
  ProjectsBdBdKeyGraphRoute: typeof ProjectsBdBdKeyGraphRoute
  ProjectsSpecPjKeyIntegrationTestRoute: typeof ProjectsSpecPjKeyIntegrationTestRoute
  ProjectsSpecPjKeyIndexRoute: typeof ProjectsSpecPjKeyIndexRoute
}

const ProjectsRouteChildren: ProjectsRouteChildren = {
  ProjectsPjKeyRoute: ProjectsPjKeyRouteWithChildren,
  ProjectsAcDivBoardRoute: ProjectsAcDivBoardRoute,
  ProjectsAllPjBoardRoute: ProjectsAllPjBoardRoute,
  ProjectsAssignmentHistoryRoute: ProjectsAssignmentHistoryRoute,
  ProjectsLightTasksRoute: ProjectsLightTasksRoute,
  ProjectsLogiDivBoardRoute: ProjectsLogiDivBoardRoute,
  ProjectsMallDivBoardRoute: ProjectsMallDivBoardRoute,
  ProjectsPjSandboxRoute: ProjectsPjSandboxRoute,
  ProjectsPmoBoardRoute: ProjectsPmoBoardRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  ProjectsBdBdKeyRoute: ProjectsBdBdKeyRoute,
  ProjectsBdIndexRoute: ProjectsBdIndexRoute,
  ProjectsSpecIndexRoute: ProjectsSpecIndexRoute,
  ProjectsBdBdKeyGraphRoute: ProjectsBdBdKeyGraphRoute,
  ProjectsSpecPjKeyIntegrationTestRoute: ProjectsSpecPjKeyIntegrationTestRoute,
  ProjectsSpecPjKeyIndexRoute: ProjectsSpecPjKeyIndexRoute,
}

const ProjectsRouteWithChildren = ProjectsRoute._addFileChildren(
  ProjectsRouteChildren,
)

interface QaRouteChildren {
  QaIdRoute: typeof QaIdRoute
  QaIndexRoute: typeof QaIndexRoute
}

const QaRouteChildren: QaRouteChildren = {
  QaIdRoute: QaIdRoute,
  QaIndexRoute: QaIndexRoute,
}

const QaRouteWithChildren = QaRoute._addFileChildren(QaRouteChildren)

interface QaResponsibilityRouteChildren {
  QaResponsibilityIssueKeyRoute: typeof QaResponsibilityIssueKeyRoute
  QaResponsibilityIndexRoute: typeof QaResponsibilityIndexRoute
}

const QaResponsibilityRouteChildren: QaResponsibilityRouteChildren = {
  QaResponsibilityIssueKeyRoute: QaResponsibilityIssueKeyRoute,
  QaResponsibilityIndexRoute: QaResponsibilityIndexRoute,
}

const QaResponsibilityRouteWithChildren =
  QaResponsibilityRoute._addFileChildren(QaResponsibilityRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountsRoute: AccountsRouteWithChildren,
  BugEvaluationRoute: BugEvaluationRouteWithChildren,
  CcCommandMatrixRoute: CcCommandMatrixRoute,
  CcUsageRoute: CcUsageRoute,
  DashboardRoute: DashboardRoute,
  DbDictionaryRoute: DbDictionaryRouteWithChildren,
  DesignSearchRoute: DesignSearchRoute,
  EngineerEvaluationsRoute: EngineerEvaluationsRouteWithChildren,
  EvaluationRoute: EvaluationRoute,
  GithubActivityRoute: GithubActivityRoute,
  ImprovementsRoute: ImprovementsRoute,
  KnowledgeWikiRoute: KnowledgeWikiRouteWithChildren,
  KpiRoute: KpiRoute,
  LoginRoute: LoginRoute,
  McpUsageRoute: McpUsageRoute,
  MembersRoute: MembersRouteWithChildren,
  MyPageRoute: MyPageRoute,
  OpsRoute: OpsRouteWithChildren,
  ProjectsRoute: ProjectsRouteWithChildren,
  QaRoute: QaRouteWithChildren,
  QaResponsibilityRoute: QaResponsibilityRouteWithChildren,
  ReliabilityRoute: ReliabilityRoute,
  SettingsRoute: SettingsRoute,
  TeamAssignmentsRoute: TeamAssignmentsRoute,
  IdtDesignerNicknameRoute: IdtDesignerNicknameRoute,
  OrgIssuesBoardIdRoute: OrgIssuesBoardIdRoute,
  TeamMeetingsSeriesIdRoute: TeamMeetingsSeriesIdRoute,
  CuttysarkIndexRoute: CuttysarkIndexRoute,
  OrgIssuesIndexRoute: OrgIssuesIndexRoute,
  TeamMeetingsIndexRoute: TeamMeetingsIndexRoute,
  CuttysarkSessionIdOperateRoute: CuttysarkSessionIdOperateRoute,
  CuttysarkSessionIdStageRoute: CuttysarkSessionIdStageRoute,
  CuttysarkSessionIdIndexRoute: CuttysarkSessionIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
